import React from 'react';
import './styles/theme.css';
import { ThemeProvider } from './components/theme/themeContext';
import {
  // BrowserRouter as Router,
  HashRouter as Router, // change back to browser when no longer embedding
  Routes,
  Route
} from 'react-router-dom';
import PlaidIntegrationPage from './pages/plaidIntegration';

function App() {
  return (
    <Router>
      <ThemeProvider>
      <div className="main-theme">
        <Routes>
          <Route path="/" element={<PlaidIntegrationPage />} />
        </Routes>
      </div>
      </ThemeProvider>
    </Router>
  );
}

export default App;
